import type { PageMeta } from "../shared/seo";

/** Keep the document head in sync after client-side /events navigation. Does not touch visible copy. */
export function applyDocumentMeta(meta: PageMeta, opts?: { keepTitle?: boolean }): void {
  if (!opts?.keepTitle) document.title = meta.title;
  setAttr('meta[name="description"]', "content", meta.description);
  setAttr('link[rel="canonical"]', "href", meta.canonical);
  setAttr('meta[property="og:title"]', "content", meta.ogTitle);
  setAttr('meta[property="og:description"]', "content", meta.ogDescription);
  setAttr('meta[property="og:url"]', "content", meta.canonical);
  setAttr('meta[name="twitter:title"]', "content", meta.ogTitle);
  setAttr('meta[name="twitter:description"]', "content", meta.ogDescription);
  setAttr('meta[name="robots"]', "content", meta.robots);
  const ld = document.querySelector("script[type='application/ld+json']");
  if (ld) ld.textContent = JSON.stringify(meta.jsonLd);
}

function setAttr(selector: string, name: string, value: string): void {
  document.querySelector(selector)?.setAttribute(name, value);
}
